<template>
  <transition name="fade">
    <b-alert
      v-if="visible"
      show
      variant="info"
      class="sse-reconnect-banner shadow-lg"
      dismissible
      role="status"
      aria-live="polite"
      @dismissed="visible = false"
      @keydown.esc.native="visible = false"
    >
      <div class="banner-content">
        <div class="text-block">
          <strong class="title">Conexão recuperada</strong>
          <small class="desc d-block">
            Para evitar dados inconsistentes, recomenda-se atualizar a página.
          </small>
          <small v-if="attempts !== null" class="muted">
            (Tentativas: {{ attempts }})
          </small>
        </div>

        <div class="action-group">
          <b-button size="sm" class="btn-action" @click="reload">
            Atualizar agora
          </b-button>
          <b-button
            size="sm"
            variant="outline-secondary"
            class="btn-dismiss"
            @click="visible = false"
          >
            Fechar
          </b-button>
        </div>
      </div>
    </b-alert>
  </transition>
</template>

<script>
export default {
  name: 'SSEReconnectBanner',
  props: {
    /** Fecha automaticamente depois de X ms (null para desativar) */
    autoHideMs: {
      type: [Number, null],
      default: null
    }
  },
  data() {
    return {
      visible: false,
      attempts: null,
      hideTimer: null
    }
  },
  mounted() {
    window.addEventListener('sse:reconnected', this.onReconnected)
  },
  beforeDestroy() {
    window.removeEventListener('sse:reconnected', this.onReconnected)
    if (this.hideTimer) clearTimeout(this.hideTimer)
  },
  methods: {
    onReconnected(e) {
      this.attempts =
        typeof e?.detail?.attempts === 'number' ? e.detail.attempts : null
      this.visible = true

      if (this.hideTimer) clearTimeout(this.hideTimer)
      if (this.autoHideMs && Number.isFinite(this.autoHideMs)) {
        this.hideTimer = setTimeout(() => {
          this.visible = false
        }, this.autoHideMs)
      }
    },
    reload() {
      window.location.reload()
    }
  }
}
</script>

<style scoped>
/* ---- Transição ---- */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* ---- Banner container ---- */
.sse-reconnect-banner {
  position: fixed;
  left: 8px;
  right: 8px;
  /* Respeita área segura (notch) em PWAs/mobile */
  bottom: calc(8px + env(safe-area-inset-bottom, 0));
  z-index: 2000;
  padding: 0.75rem 0.75rem;
  /* Bordas mais arredondadas para mobile */
  border-radius: 12px;
}

/* ---- Conteúdo interno ---- */
.banner-content {
  display: flex;
  flex-direction: column; /* mobile-first */
  gap: 0.5rem;
}

/* Bloco de texto */
.text-block .title {
  line-height: 1.2;
}
.text-block .desc {
  margin-top: 2px;
}
.text-block .muted {
  color: rgba(0, 0, 0, 0.55);
}
:root.dark .text-block .muted,
.dark .text-block .muted {
  color: rgba(255, 255, 255, 0.7);
}

/* Ações: empilhadas e com largura total no mobile */
.action-group {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.5rem;
}
.action-group .btn-action,
.action-group .btn-dismiss {
  width: 100%;
  touch-action: manipulation; /* melhora resposta no mobile */
}

/* ---- Layout para telas maiores ---- */
@media (min-width: 576px) {
  .sse-reconnect-banner {
    /* Centraliza e limita a largura no desktop/tablet */
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: 24px;
    max-width: 520px;
    border-radius: 14px;
    padding: 0.9rem 1rem;
  }

  .banner-content {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .action-group {
    flex-direction: row;
    width: auto;
  }

  .action-group .btn-action,
  .action-group .btn-dismiss {
    width: auto;
    min-width: 140px;
  }
}

/* ---- Preferência do usuário por menos animação ---- */
@media (prefers-reduced-motion: reduce) {
  .fade-enter-active,
  .fade-leave-active {
    transition: none;
  }
}
</style>
